import CategorySwitcher from './CategorySwitcher.vue'

const blogComponents = [CategorySwitcher]

export default blogComponents
